import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { getJobNotes, addJobNotes } from "../service/JobService";

export default function JobNotes({ jobId }) {
    const [jobNotes, setJobNotes] = useState([]);
    const [newNote, setNewNote] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');

    useEffect(() => {
        if (jobId) {
            refreshJobNotes();
        }
    }, [jobId]);

    function refreshJobNotes() {
        getJobNotes(jobId).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    setJobNotes(result);
                });
            } else {
                response.text().then(result => {
                    console.log("Error fetching job notes:", result);
                });
            }
        }).catch(error => console.log('error', error));
    }

    function handleAddNote(e) {
        e.preventDefault();
        if (!newNote.trim()) return;

        setIsLoading(true);
        setResponseMessage('');
        
        addJobNotes(jobId, newNote).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    setResponseMessage('Note added successfully');
                    setNewNote('');
                    refreshJobNotes();
                });
            } else {
                response.text().then(result => {
                    setResponseMessage(result);
                });
            }
        }).catch(error => console.log('error', error))
        .finally(() => setIsLoading(false));
    }

    return (
        <div className="job-notes-container">
            <h4>Job Notes</h4>
            <div className="job-notes-list" style={{ maxHeight: '300px', overflowY: 'auto', marginBottom: '15px' }}>
                {jobNotes && jobNotes.length > 0 ? (
                    jobNotes.map((note, index) => (
                        <div key={index} className="job-note" style={{ 
                            padding: '10px', 
                            marginBottom: '10px', 
                            backgroundColor: '#f8f9fa', 
                            borderRadius: '5px',
                            border: '1px solid #dee2e6'
                        }}>
                            <div><strong>{note.timestamp ? new Date(note.timestamp).toLocaleString() : 'Unknown Date'}</strong> - {note.createdby || ''}</div>
                            <div>{note.note}</div>
                        </div>
                    ))
                ) : (
                    <div className="no-notes">No notes available</div>
                )}
            </div>
            
            <Form onSubmit={handleAddNote}>
                <Row>
                    <Col>
                        <Form.Control
                            as="textarea"
                            value={newNote}
                            placeholder="Add a new note..."
                            onChange={(e) => setNewNote(e.target.value)}
                            style={{ height: '100px' }}
                        />
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Button 
                            type="submit" 
                            disabled={isLoading || !newNote.trim()} 
                            variant="primary"
                        >
                            {isLoading ? 'Adding...' : 'Add Note'}
                        </Button>
                        {responseMessage && (
                            <span className="ml-2" style={{ marginLeft: '10px' }}>
                                {responseMessage}
                            </span>
                        )}
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
